/** Coerce URL search values (react-router may parse numeric codes as numbers). */
export const parseSearchParamString = (value) => {
  if (value == null || value === "") {
    return undefined;
  }
  const text = String(value).trim();
  return text === "" ? undefined : text;
};

export const isVerifySearchFlag = (value) =>
  value === "true" || value === true;

export const isResetPassSearchFlag = (value) =>
  value === "true" || value === true;

export const normalizeVerificationCode = (code) => {
  if (!code) return "";
  const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
  const normalized = String(code)
    .trim()
    .replace(/[٠-٩]/g, (digit) => {
      const index = arabicDigits.indexOf(digit);
      return index >= 0 ? String(index) : digit;
    })
    .replace(/\D/g, "");
  return normalized.slice(0, 6);
};

export const codeToDigits = (code) => {
  const normalized = normalizeVerificationCode(code);
  if (normalized.length !== 6) {
    return ["", "", "", "", "", ""];
  }
  return normalized.split("");
};

export const resolveRegisterVerifyEntry = (search) => {
  if (!search?.email || !isVerifySearchFlag(search.isVerify)) {
    return null;
  }

  return {
    email: search.email,
    code: search.code,
  };
};

export const searchParamsToVerifySearch = (searchParams) => ({
  isVerify: parseSearchParamString(searchParams.get("isVerify")),
  isResetPass: parseSearchParamString(searchParams.get("isResetPass")),
  email: parseSearchParamString(searchParams.get("email")),
  code: parseSearchParamString(searchParams.get("code")),
});

export const resolveVerifyEntry = (search) => {
  if (!search?.email) {
    return null;
  }

  if (isVerifySearchFlag(search.isVerify)) {
    return {
      mode: "register",
      email: search.email,
      code: search.code,
    };
  }

  if (isResetPassSearchFlag(search.isResetPass)) {
    return {
      mode: "reset",
      email: search.email,
      code: search.code,
    };
  }

  return null;
};
